/* globals Modernizr */

'use strict';

const _ = require('lodash');

function requireCompleteSignInController(AppActions, IdentityService, ResourceHelper, UserStore, SaturnGrowl, AnalyticsService, IntercomService) {
  const vm = this;

  // general
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;

  // dialog
  vm.position = 'center';
  vm.animate = 'fadeInDown fadeOutDown';

  // form
  const NORMAL_TEXT = 'Save';
  const LOADING_TEXT = 'Saving...';
  vm.sendingForm = false;
  vm.buttonText = NORMAL_TEXT;

  vm.data = {
    organization: ''
  };

  vm.industrySelectorOptions = {
    constructionProfessional: 'Construction Professional',
    droneServiceProvider: 'Drone Service Provider',
    recreationalPilot: 'Recreational Pilot',
    other: 'Other'
  };

  vm.industrySelectorValue = null;
  vm.customIndustrySelector = null;

  // handlers
  vm._handleSavingError = (err) => {
    console.warn('\nSIGN UP - Tracking Error', err);
    return SaturnGrowl.newGrowl('Your changes were unable to save, please try again.', {
      type: 'alert',
      id: 'signin-complete-error'
    });
  };

  // IMPORTANT: auth_souce is a property name registered on keen.io since a while ago, please do not fix the typo.
  vm._handleSavingSuccess = (auth_souce) => {
    const email = IdentityService.getUser().email;
    let industry;

    if (vm.industrySelectorValue === 'other') {
      industry = vm.customIndustrySelector;
    }
    else {
      industry = vm.industrySelectorOptions[vm.industrySelectorValue];
    }

    return AnalyticsService.track('[CORE] Sign Up Success', 'Sign Up Success', { email, industry, auth_souce })
      .then(AnalyticsService.page.bind(vm, {
        title: 'Thank you!',
        path: '/signup/thankyou/',
        url: 'https://app.skycatch.com/signup/thankyou/'
      }))
      .then(() => {
        console.warn('\nSIGN UP - events sent.');
        return SaturnGrowl.newGrowl('Your information have been updated!', {
          type: 'success',
          id: 'signin-complete-success',
          time: 3500
        });
      });
  };

  vm._deleteRequireCompleteSignInMeta = () => {
    return UserStore.destroyMetaByKey('requireCompleteSignIn')
      .then((user) => IdentityService.updateUserMeta(user.meta));
  };

  vm._updateOrganizationName = () => {
    const OrganizationResource = ResourceHelper.getResource('Organization');
    const orgId = IdentityService.getCurrentOrganization().id;
    const newOrganizationName = { name: vm.data.organization };

    return OrganizationResource.update(orgId, newOrganizationName)
      .then((organization) => {
        IntercomService.update({ 'Core_Last_Organization_Name': organization.name });
        IntercomService.update({ 'Core_Last_Organization_Id': organization.id });
      });
  };

  vm.saveForm = () => {
    const user = IdentityService.getUser();
    let userMetaSource = _.find(user.meta, { key: 'requireCompleteSignIn' });

    vm.sendingForm = true;
    vm.buttonText = LOADING_TEXT;

    if (userMetaSource) {
      userMetaSource = userMetaSource.value;
    }

    return vm._deleteRequireCompleteSignInMeta()
      .then(() => {
        if (vm.industrySelectorValue !== 'recreationalPilot') {
          return vm._updateOrganizationName();
        }
        return true;
      })
      .then(() => vm._handleSavingSuccess(userMetaSource))
      .catch((err) => vm._handleSavingError(err))
      .finally(() => {
        vm.sendingForm = false;
        vm.buttonText = NORMAL_TEXT;
        return AppActions.CheckCompleteSignIn.dispatch();
      });
  };
}

requireCompleteSignInController.$inject = ['AppActions', 'IdentityService', 'ResourceHelper', 'UserStore', 'SaturnGrowl', 'AnalyticsService', 'IntercomService'];

module.exports = requireCompleteSignInController;



// WEBPACK FOOTER //
// ./src/app/requireCompleteSignIn/requireCompleteSignInController.js